module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_26 (33).988a7a8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_26 (33).mp4
// module id = 808
// module chunks = 1